
import React, { useState } from 'react';
// import { X, ChevronDown, Pencil, Plus, Check } from 'lucide-react';
// import { Button } from "@/components/ui/button";
// import { Input } from "@/components/ui/input";
// import { Textarea } from "@/components/ui/textarea";
import { Modal, Button, Form, Dropdown } from '@themesberg/react-bootstrap';
import { X, Pencil, Plus, Check } from 'lucide-react';
// import { Modal } 

const QuestionDialog = ({ isOpen, onClose, mode, questionData }) => {
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [questionText, setQuestionText] = useState(questionData?.text || '');
  const [questionType, setQuestionType] = useState(questionData?.type || 'Input Text');
  const isViewMode = mode === 'view';
  const isCreateMode = mode === 'create';
  const title = isViewMode ? 'View Exchange Questions' : 
               isCreateMode ? 'Exchange Questions > Create Question' : 
               'Exchange Questions > Edit Question';

  const handleSave = () => {
    if (questionData?.status === 'Assigned') {
      setShowConfirmDialog(true);
    } else {
      saveChanges();
    }
  };

  const saveChanges = () => {
    alert(`${isCreateMode ? 'Created' : 'Updated'}: ${questionText}`);
    setShowConfirmDialog(false);
    onClose();
  };

  return (
    <>
      <Modal show={isOpen} onHide={onClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isViewMode ? (
            <ViewQuestionContent questionData={questionData} />
          ) : (
            <EditQuestionContent 
              questionText={questionText}
              setQuestionText={setQuestionText}
              questionType={questionType}
              setQuestionType={setQuestionType}
              isCreateMode={isCreateMode}
              onSave={handleSave}
              onCancel={onClose}
            />
          )}
        </Modal.Body>
      </Modal>

      <Modal show={showConfirmDialog} onHide={() => setShowConfirmDialog(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm {isCreateMode ? 'Creation' : 'Edit'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{isCreateMode 
            ? "This question will be assigned to a template. Are you sure you want to proceed?"
            : "This question is assigned to a template. Editing may affect existing templates."}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirmDialog(false)}>Cancel</Button>
          <Button variant="primary" onClick={saveChanges}>Confirm</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const ViewQuestionContent = ({ questionData }) => (
  <div>
    <h5>Question Details</h5>
    <p><strong>Question Text:</strong> {questionData.text}</p>
    <p><strong>Question Type:</strong> {questionData.type}</p>
  </div>
);

const EditQuestionContent = ({ questionText, setQuestionText, questionType, setQuestionType, isCreateMode, onSave, onCancel }) => (
  <Form>
    <Form.Group>
      <Form.Label>Question Text</Form.Label>
      <Form.Control type="text" value={questionText} onChange={(e) => setQuestionText(e.target.value)} />
    </Form.Group>
    <Form.Group>
      <Form.Label>Question Type</Form.Label>
      <Dropdown onSelect={(e) => setQuestionType(e)}>
        <Dropdown.Toggle variant="secondary">
          {questionType}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item eventKey="Input Text">Input Text</Dropdown.Item>
          <Dropdown.Item eventKey="Single Select (Radio Button)">Single Select (Radio Button)</Dropdown.Item>
          <Dropdown.Item eventKey="Multi Select (Check Box)">Multi Select (Check Box)</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </Form.Group>
    <div className="d-flex justify-content-end mt-3">
      <Button variant="secondary" onClick={onCancel}>Cancel</Button>
      <Button variant="primary" onClick={onSave} className="ms-2">{isCreateMode ? 'Create' : 'Save'}</Button>
    </div>
  </Form>
);

export default QuestionDialog;


// const ViewQuestionContent = ({ questionData }) => {
//   return (
//     <div className="space-y-4">
//       <div>
//         <h3 className="form-label">Question Details</h3>
//       </div>
      
//       <div>
//         <h3 className="form-label">Question Text</h3>
//         <div className="bg-gray-50 p-3 rounded-md border border-gray-300">
//           {questionData.text}
//         </div>
//       </div>
      
//       <div>
//         <h3 className="form-label">Question Type</h3>
//         <div className="bg-gray-50 p-3 rounded-md border border-gray-300">
//           {questionData.type}
//         </div>
//       </div>
      
//       <div>
//         <h3 className="form-label">Answer Options</h3>
//         <div className="space-y-2">
//           {Array.isArray(questionData.answerOptions) ? (
//             questionData.answerOptions.map((option, index) => (
//               <div key={index} className="flex items-center gap-2">
//                 <input type="checkbox" disabled className="h-4 w-4" />
//                 <span>{option}</span>
//               </div>
//             ))
//           ) : (
//             <div className="bg-gray-50 p-3 rounded-md border border-gray-300">
//               {questionData.answerOptions}
//             </div>
//           )}
//         </div>
//       </div>
      
//       <div>
//         <h3 className="form-label">Assigned Template</h3>
//         <div className="bg-gray-50 p-3 rounded-md border border-gray-300">
//           Smartphone Exchange Qs
//         </div>
//       </div>
//     </div>
//   );
// };

// const EditQuestionContent = ({
//   questionData,
//   questionText,
//   setQuestionText,
//   questionType,
//   setQuestionType,
//   isTypeDropdownOpen,
//   setIsTypeDropdownOpen,
//   isTemplateDropdownOpen,
//   setIsTemplateDropdownOpen,
//   questionTypes,
//   templates,
//   onSave,
//   onCancel,
//   isCreateMode
// }) => {
//   const [answerOptions, setAnswerOptions] = useState(
//     Array.isArray(questionData?.answerOptions) 
//       ? questionData.answerOptions.filter((opt) => !opt.startsWith('+'))
//       : []
//   );
  
//   const addAnswerOption = () => {
//     setAnswerOptions([...answerOptions, '']);
//   };
  
//   const updateAnswerOption = (index, value) => {
//     const newOptions = [...answerOptions];
//     newOptions[index] = value;
//     setAnswerOptions(newOptions);
//   };
  
//   const removeAnswerOption = (index) => {
//     setAnswerOptions(answerOptions.filter((_, i) => i !== index));
//   };
  
//   const showAnswerOptions = ['Single Select (Radio Button)', 'Multi Select (Check Box)', 'Dropdown'].includes(questionType);
  
//   return (
//     <div className="space-y-4">
//       <div>
//         <h3 className="form-label font-medium">Question Details</h3>
//       </div>
      
//       <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-start">
//         <div className="md:col-span-1">
//           <h3 className="form-label">Question Text</h3>
//         </div>
//         <div className="md:col-span-3">
//           <Textarea 
//             className="form-control" 
//             value={questionText} 
//             onChange={(e) => setQuestionText(e.target.value)} 
//             placeholder="Enter question text"
//           />
//         </div>
//       </div>
      
//       <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-start">
//         <div className="md:col-span-1">
//           <h3 className="form-label">Question Type</h3>
//         </div>
//         <div className="md:col-span-3">
//           <div className="relative">
//             <div 
//               className="form-select flex justify-between items-center cursor-pointer"
//               onClick={() => setIsTypeDropdownOpen(!isTypeDropdownOpen)}
//             >
//               <span>{questionType}</span>
//               <ChevronDown className="h-4 w-4 text-gray-500" />
//             </div>
            
//             {isTypeDropdownOpen && (
//               <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg">
//                 {questionTypes.map((type, index) => (
//                   <div 
//                     key={index} 
//                     className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
//                     onClick={() => {
//                       setQuestionType(type);
//                       setIsTypeDropdownOpen(false);
//                     }}
//                   >
//                     {type}
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
      
//       {showAnswerOptions ? (
//         <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-start">
//           <div className="md:col-span-1">
//             <h3 className="form-label">Answer Options</h3>
//           </div>
//           <div className="md:col-span-3 space-y-2">
//             {answerOptions.map((option, index) => (
//               <div key={index} className="flex items-center gap-2">
//                 <input 
//                   type={questionType.includes('Multi') ? 'checkbox' : 'radio'} 
//                   disabled 
//                   className="h-4 w-4"
//                 />
//                 <Input 
//                   value={option} 
//                   onChange={(e) => updateAnswerOption(index, e.target.value)}
//                   className="form-control"
//                   placeholder="Enter option text"
//                 />
//                 <button 
//                   onClick={() => removeAnswerOption(index)}
//                   className="text-gray-500 hover:text-red-500"
//                 >
//                   <X size={18} />
//                 </button>
//               </div>
//             ))}
//             <Button 
//               variant="outline" 
//               onClick={addAnswerOption}
//               className="btn btn-secondary mt-2"
//             >
//               <Plus className="h-4 w-4 mr-1" /> Add Option
//             </Button>
//           </div>
//         </div>
//       ) : (
//         <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-start">
//           <div className="md:col-span-1">
//             <h3 className="form-label">Answer Options</h3>
//           </div>
//           <div className="md:col-span-3">
//             <Input 
//               className="form-control bg-gray-50" 
//               value={
//                 questionType === 'Input Text' ? '(User-entered text)' :
//                 questionType === 'File Upload' ? '(Image Upload Button)' :
//                 questionType === 'Number Input' ? '(User enters a number)' :
//                 '(User-entered text)'
//               } 
//               readOnly
//             />
//           </div>
//         </div>
//       )}
      
//       <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-start">
//         <div className="md:col-span-1">
//           <h3 className="form-label">Assign to</h3>
//         </div>
//         <div className="md:col-span-3">
//           <div className="flex justify-between gap-2">
//             <div className="w-full relative">
//               <div 
//                 className="form-select flex justify-between items-center cursor-pointer"
//                 onClick={() => setIsTemplateDropdownOpen(!isTemplateDropdownOpen)}
//               >
//                 <span>{questionData?.status === 'Assigned' ? 'Smartphone Exchange Qs' : 'Select template'}</span>
//                 <ChevronDown className="h-4 w-4 text-gray-500" />
//               </div>
              
//               {isTemplateDropdownOpen && (
//                 <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg">
//                   {templates.map((template, index) => (
//                     <div 
//                       key={index} 
//                       className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
//                       onClick={() => setIsTemplateDropdownOpen(false)}
//                     >
//                       {template}
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//             <Button 
//               variant="outline" 
//               className="btn btn-secondary whitespace-nowrap"
//             >
//               <Plus className="h-4 w-4 mr-1" /> Create New Template
//             </Button>
//           </div>
//         </div>
//       </div>
      
//       <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200">
//         <Button 
//           variant="secondary" 
//           onClick={onCancel}
//           className="btn btn-secondary"
//         >
//           Cancel
//         </Button>
//         <Button 
//           onClick={onSave}
//           className="btn btn-primary"
//         >
//           {isCreateMode ? 'Create' : 'Save'}
//         </Button>
//       </div>
//     </div>
//   );
// };

// export default QuestionDialog;
